export type ThemeType = "default" | "customer1";

export class ThemeManager {
  static setTheme(theme: ThemeType) {
    localStorage.setItem("app-theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
  }

  static getTheme(): ThemeType {
    return (localStorage.getItem("app-theme") as ThemeType) || "default";
  }

  static initTheme() {
    this.setTheme(this.getTheme());
  }
}
